import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import { SITE } from '@/constants/site';
import HomeHero from './components/HomeHero';
import TickerBar from './components/TickerBar';
import CategorySection from './components/CategorySection';
import HotTopicsSection from './components/HotTopicsSection';
import DiscussionFeedSection from './components/DiscussionFeedSection';
import StatsSection from './components/StatsSection';
import FaqPreviewSection from './components/FaqPreviewSection';
import CtaBanner from './components/CtaBanner';

export default function Home() {
  useSeo({
    title: `${SITE.name} - 热点热议话题与讨论区实时动态`,
    description:
      '瓜田观察聚焦热点事件与相关人物，梳理事件时间线、各方说法与讨论区实时动态，看当事人怎么说、网友怎么评，理性吃瓜一站搞定。',
    keywords: '热点热议,热点话题,讨论区,事件时间线,各方回应,网络讨论,瓜田观察',
    path: '/',
    jsonLd: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebSite',
          name: SITE.name,
          url: window.location.origin,
          description: SITE.description,
          inLanguage: 'zh-CN',
          potentialAction: {
            '@type': 'SearchAction',
            target: `${window.location.origin}/topics?q={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        },
        {
          '@type': 'Organization',
          name: SITE.name,
          url: window.location.origin,
          email: SITE.email,
          foundingDate: SITE.since,
          description: SITE.description,
        },
      ],
    },
  });

  return (
    <SiteLayout>
      <HomeHero />
      <TickerBar />
      <CategorySection />
      <HotTopicsSection />
      <DiscussionFeedSection />
      <StatsSection />
      <FaqPreviewSection />
      <CtaBanner />
    </SiteLayout>
  );
}